<template>
    <v-flex>
        <v-card class="add-card">
        <v-form
            @submit.prevent="createCard"
            v-model="validCard"
            @keydown.prevent.enter
            v-if="!creatingCard">
            <v-text-field
                v-model="card.title"
                label="Add card"
                :rules="notEmptyRules"
                type="text"
                required
            />
            <v-btn type="submit" icon :disabled="!validCard" color="primary"><i class="fas fa-plus"></i></v-btn>
        </v-form>
        <v-progress-circular
                v-if="creatingCard"
                :size="50"
                color="primary"
                indeterminate
                ></v-progress-circular>
        </v-card>
    </v-flex>
</template>

<script>

import regeneratorRuntime from "regenerator-runtime";
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'create-card',
    props: ['listId', 'boardId', 'createActivity', 'user'],
    data: () => ({
        board: {},
        creatingCard: false,
        validCard: false,
        card: {
            title: '',
            order: 0,
            members: [],
        },
        notEmptyRules: [(value) => !!value || ''],
    }),
    methods: {
         async createCard() {
            if(this.validCard){
                const { Cards } =  this.$FeathersVuex.api;
                this.card.boardId = this.boardId;
                this.card.listId = this.listId;

                const card = new Cards(this.card);
                this.creatingCard = true;
                await card.save();
                this.creatingCard = false;
                this.card = {
                    title: '',
                    order: 0,
                    members: [],
                };
                this.createActivity(`**${this.user.displayName}** created card **${card.title}**`)
            }
        }
    }
}
</script>

<style scoped>
.add-card {
    box-shadow: none;
}

</style>